import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { SaveBtn } from 'src/components/Common';
import { Mixpanel } from '../Mixpanel';

class Register extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      email: '',
      usernameError: '',
      passwordError: '',
      emailError: '',
      checkError: '',
      success: false,
      chkbox: true
    }
  }

  showAuthError(authError) {
    toast.error(("Registration failed!"), {
      position: toast.POSITION.BOTTOM_RIGHT
    });
    const errors = {};
    Object.keys(authError).forEach((errorInput) => {
      errors[errorInput + 'Error'] = authError[errorInput];
    })
    this.setState(errors);
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
      [[e.target.id] + 'Error']: false,
    })
  }

   handleChangeChk = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    
    if (!value) {
      this.setState({checkError: 'Необходимо дать согласие на обработку данных'});
    } else {
      this.setState({checkError: ''});
    }
    
    this.setState({
      [name]: value,
    });
  }

  submitForm = (e) => {

    if (this.state.checkError !=='') {
      this.setState({email: ''});
    }
    Mixpanel.track('Send registration');
    e.preventDefault();
    this.props.onSubmit(this.state.username, this.state.password, this.state.email)
      .then(() => {
        this.setState({
          success: true,
        });
      })
      .catch((err) => this.showAuthError(err.response.data));
  }
  
  changeFormState(formState) {
    this.props.onFormStateChange(formState);
  }

  render() {
    const { formStates, requestInProgress } = this.props;
    const { usernameError, passwordError, emailError, checkError } = this.state;
    if (this.state.success) {
      return(
        <div className="auth-success">
          <div className="text">
            Для активации аккаунта перейдите по ссылке, которую мы отправили на электронную почту, указанную при регистрации
          </div>
        </div>
      )
    }
    return (
      <form className="auth-form" onSubmit={this.submitForm}>
        <div className='title'>Регистрация</div>
        <div className="auth-form-row">
          <label htmlFor="email">Почта</label>
          <input type="email" id='email' autoFocus={true} placeholder='почта'
            className={emailError ? 'input-error' : ''}
            disabled={requestInProgress}
            onChange={this.handleInputChange} value={this.state.email} />
          {emailError && <span className="error-help-block">{emailError}</span>}
        </div>
        <div className="auth-form-row">
          <label htmlFor="username">Никнейм</label>
          <input type="text" id='username' placeholder='никнейм'
            className={usernameError ? 'input-error' : ''}
            disabled={requestInProgress}
            onChange={this.handleInputChange} value={this.state.name} />
          {usernameError && <span className="error-help-block">{usernameError}</span>}
        </div>
        <div className="auth-form-row">
          <label htmlFor="password">Пароль</label>
          <input id='password' type="password" placeholder='пароль'
            className={passwordError ? 'input-error' : ''}
            disabled={requestInProgress}
            onChange={this.handleInputChange} value={this.state.password} />
          {passwordError && <span className="error-help-block">{passwordError}</span>}
        </div>
        <div>
          <label className="container">
            <p> Я даю согласие на обработку своих персональных данных.</p>
            <input type="checkbox" defaultChecked={this.state.chkbox} onChange={this.handleChangeChk}/>
            <span className="checkmark"></span>
          </label>
          {checkError && <span className="error-help-block">{checkError}</span>}
        </div>
        <div className="auth-form-row auth-buttons-block">
          <SaveBtn saveText="Регистрация" cancelText="Отменить"
            onSave={this.submitForm}
            onCancel={this.changeFormState.bind(this, formStates.LOGIN)}
            disabled={requestInProgress}
          />
        </div>
      </form>
    );
  }
}

Register.propTypes = {
  requestInProgress: PropTypes.bool.isRequired,
  formStates: PropTypes.object.isRequired,
  onFormStateChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Authorization/Register.js